export default "__VITE_ASSET__DFlD9nNw__"